export default class DeviceAudioUnsupportedError extends Error {
  constructor() {
    super('This feature is not supported by your browser')
    this.name = 'DeviceAudioUnsupportedError'
  }
}
